import { de } from "./de";
import { en } from "./en";
import { es } from "./es";
import { fr } from "./fr";
import { gb } from "./gb";
import { sv } from "./sv";

export const resources = { de, en, es, gb, fr, sv };
